$(document).ready(function () {

    const donationButton = document.getElementById('btn_donation');
    const nextStepButton = document.getElementById('next_step');
    const donationPopup = document.querySelector('.donation__popup');
    const donationPopup_thanks = document.querySelector('.donation__popup-thanks');
    const donationPopupNext = document.querySelector('.donation__popup-next');
    const closePopup = document.querySelector('.close');
    const closePopup_thanks = document.querySelector('.close-thanks');
    const closePopupNext = document.querySelector('.close-next');
    var modal = document.getElementById("myModal");
    var modal2 = document.getElementById("myModal2");
    var modal_thanks = document.getElementById("modal-thanks");

    donationButton.addEventListener('click', () => {
        donationPopup.classList.toggle('hidden');
        modal.style.display = "block";
        document.body.classList.toggle('overflow-hidden');
    });
    closePopup.addEventListener('click', () => {
        donationPopup.classList.toggle('hidden');
        modal.style.display = "none";
    });
    closePopup_thanks.addEventListener('click', () => {
        donationPopup_thanks.classList.toggle('hidden');
        modal_thanks.style.display = "none";
    });
    nextStepButton.addEventListener('click', () => {
        donationPopup.classList.toggle('hidden');
        modal.style.display = "none";
        donationPopupNext.classList.toggle('hidden');
        modal2.style.display = "block";
    });
    closePopupNext.addEventListener('click', () => {
        donationPopupNext.classList.toggle('hidden');
        modal2.style.display = "none";
        document.body.classList.toggle('overflow-hidden');
    });


    if ($('.donation-slider__top').length) {
        $('.donation-slider__top').on('init', function (event, slick) {
            $('.donation-slider__top').append('<div class="slider-count form__number"><p><span id="current1">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.donation-slider__top').on('afterChange', function (event, slick, currentSlide) {
            $('.slider-count #current1').html(currentSlide + 1);
        });
        $('.donation-slider__top').slick(
            {
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                // autoplay: true,
                autoplaySpeed: 7000,
                variableWidth: true,
                infiniste: true,
                prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
                nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            speed: 700,
                            // autoplay: true,
                            autoplaySpeed: 7000,
                            variableWidth: false,
                            centerPadding: '40px',
                            dots: false,
                            arrows: false
                        }
                    }
                ]
            }
        );
    }

    if ($('.donation-slider__bottom').length) {
        $('.donation-slider__bottom').on('init', function (event, slick) {
            $('.donation-slider__bottom').append('<div class="slider-count form__number"><p><span id="current2">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.donation-slider__bottom').on('afterChange', function (event, slick, currentSlide) {
            $('.slider-count #current2').html(currentSlide + 1);
        });

        $('.donation-slider__bottom').slick(
            {
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                // autoplay: true,
                autoplaySpeed: 7000,
                variableWidth: true,
                infiniste: true,
                prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
                nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: false,
                            dots: false,
                            arrows: false
                        }
                    }
                ]
            }
        );
    }

});



